import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 8px;
`;

export const TitleTextWrapper = styled.div`
  font-weight: 500;
`;

export const LinkListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const LinkTextWrapper = styled.a`
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Muestra solo 2 líneas de texto */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
`;

export const LinkIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const ExternalLinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
  }
`;

export const LinkType = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const StyledButton = styled(Button)`
  padding: 6px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.blue6};
  &:hover {
    background-color: ${({ theme }) => theme.colors.blue6} !important;
    color: ${({ theme }) => theme.colors.white} !important;
  }
`;
